import { NotFoundPage } from "./NotFoundPage";

import type { RouteObject } from "react-router-dom";

export const BASE_ROUTES: RouteObject[] = [
    {
        path: "*",
        element: <NotFoundPage />,
    },
];
